export const API_SERVER_URL =
  process.env["REACT_APP_API_SERVER_URL_" + process.env.REACT_APP_ENV] +
  process.env["REACT_APP_API_VERSION_URL_" + process.env.REACT_APP_ENV];
export const SOCKET_URL =
  process.env["REACT_APP_SOCKET_URL_" + process.env.REACT_APP_ENV];
